<template>
  <el-alert
    card
    class="ma-24 v-error-info"
    hide-close
    :type="errorType"
  >
    <slot>
      <div>
        <slot name="description">
          {{ errorMessage }}
        </slot>
      </div>
      <div v-if="!isErrorDetailEmpty">
        <toggle-details>
          <el-scrollbar
            class="error-details"
          >
            <div class="px-16 py-8">
              <recursive-info-detail :details="errorDetails" />
            </div>
          </el-scrollbar>
        </toggle-details>
      </div>
      <div v-else-if="$slots['error-details']">
        <slot name="error-details" />
      </div>
      <template
        v-if="displayReloadButton"
        slot="actions"
      >
        <el-button
          class="refresh-button"
          type="ghost"
          @click="reloadData"
        >
          {{ $t('Try again') }}
        </el-button>
      </template>
    </slot>
  </el-alert>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import RecursiveInfoDetail from '@/common/shared/RecursiveInfoDetail.vue';
  import ToggleDetails from '@/common/shared/ToggleDetails.vue';
  import { isEmpty } from 'lodash-es';

  export default defineComponent({
    name: 'ErrorInfo',
    components: {
      RecursiveInfoDetail,
      ToggleDetails
    },
    props: {
      errorMessage: String,
      errorDetails: [Object, Array, String],
      errorType: {
        type: String,
        default: 'error'
      },
      displayReloadButton: Boolean
    },
    computed: {
      isErrorDetailEmpty(): boolean {
        return isEmpty(this.errorDetails);
      }
    },
    methods: {
      reloadData() {
        this.$emit('reloadData');
      }
    }
  });
</script>

<style scoped lang="scss">
.error-details {
  max-height: 264px;
  border-radius: $av-border-radius-2;
  background-color: $av-inversed-primary;
  border: $av-border-sm $av-brand-lighter;
}

::v-deep .details-button {
  margin-top: 8px;
}
</style>
